import { View } from 'react-native';

import { HStack, Text, VStack } from '@squire/ui';

import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';
import type { CookieItem } from './types';

type CookieItemCardProps = {
  item: CookieItem;
};

const CookieItemCard = ({ item }: CookieItemCardProps) => {
  const { t } = useScreenTranslations('CookieConsentDetails');

  return (
    <VStack style={styles.cookieItemCard}>
      <Text
        variant="m"
        color="textPrimaryInverse"
        style={styles.cookieItemName}
      >
        {item.name}
      </Text>
      <Text
        variant="s"
        color="textSecondaryInverse"
        style={styles.cookieItemDescription}
      >
        {item.description}
      </Text>

      <HStack style={styles.cookieItemMeta}>
        <View style={styles.cookieItemMetaColumn}>
          <Text variant="s" color="textTertiary">
            {t('expiry').toUpperCase()}
          </Text>
          <Text variant="s" color="textPrimaryInverse">
            {item.expiry}
          </Text>
        </View>
        <View style={styles.cookieItemMetaColumn}>
          <Text variant="s" color="textTertiary">
            {t('type').toUpperCase()}
          </Text>
          <Text variant="s" color="textPrimaryInverse">
            {item.type}
          </Text>
        </View>
      </HStack>
    </VStack>
  );
};

CookieItemCard.displayName = 'CookieItemCard';

export { CookieItemCard };
